


























import Vue from "vue";

import { AjaxDelete, AjaxGet, AjaxPost, Alert, GetClients } from "../App.vue";
import { GetAllUsersURL, GetUserURL } from "../../../shared/Shared";
import User, { roles } from "../../../shared/User";

class UsersDataClass {
  public UserList: User[] = [];
  public Councils: string[] = [];
}

export default Vue.extend({
  name: "Users",
  data() {
    return new UsersDataClass();
  },
  created() {
    this.ReloadData();
  },
  computed: {
    roles(): string[] {
      const result = [];
      for (const key of Object.keys(roles)) {
        result.push(key);
      }
      return result;
    },
  },
  methods: {
    Alert(message: string) {
      Alert(message);
    },
    CreateUser() {
      const user = new User();
      user.data.email = prompt("Enter the user's email address") ?? "";
      if (!user.data.email) {
        return;
      }
      user.password = prompt("Enter the user's initial password") ?? "";
      if (!user.password) {
        return;
      }
      this.Save(user);
    },
    SetDirty(user: User) {
      user.dirty = true;
      this.$forceUpdate();
    },
    DisplayName(user: User): string {
      let result = user.data.email;
      if (user.data.displayName) {
        result = user.data.displayName;
      }
      if (user.dirty) {
        result += "*";
      }
      return result;
    },
    Delete(user: User) {
      if (!confirm("Are you sure you wish to delete this user?")) {
        return;
      }
      AjaxDelete(GetUserURL(user.uid))
        .then(() => {
          this.ReloadData();
        })
        .catch(alert);
    },
    Save(user: User) {
      AjaxPost(GetUserURL(), user, true)
        .then(() => {
          this.ReloadData();
        })
        .catch(alert);
    },
    ReloadData() {
      GetClients()
        .then((result) => {
          this.Councils = Object.keys(result);

          return AjaxGet<{ [key: string]: User }>(GetAllUsersURL(), true);
        })
        .then((result) => {
          this.UserList.length = 0;
          for (const obj of Object.values(result)) {
            this.UserList.push(obj);
          }
          this.UserList.sort((a, b) =>
            this.DisplayName(a) > this.DisplayName(b)
              ? 1
              : this.DisplayName(b) > this.DisplayName(a)
                ? -1
                : 0
          );
          this.$forceUpdate();
        })
        .catch(Alert);
    },
  },
});
